import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import pulsar220 from "../../images/pulsar-220.jpg";
import "../../../src/product.css";

const Pulsar220 = () => {
  return (
    <>
      <Header />

      <main className="product-page container text-center">
        {/* Product Hero */}

        <h2 id="title">PULSAR 220cc</h2>

        <section className="product-hero">

          <div className="product-image-wrapper">
            <img
              src={pulsar220}
              alt="Bajaj Pulsar 220cc"
              className="product-image"
            />
          </div>

          <div className="product-info">

            <p>
              Not just a bike but a beast that has more power than you ever
              imagine. A creature that arrives swiftly and never goes unnoticed
              on any road. Have you spotted it yet? This could be your chance
              to tame it.
            </p>

          </div>
        </section>

        {/* Specifications */}
        <section className="product-specifications">

          <div className="section-heading">
            <span>TECHNICAL DETAILS</span>
            <h2>Specifications</h2>
          </div>

          <div className="spec-grid">

            <div className="spec-card">
              <span>Engine Type</span>
              <strong>4 Stroke Engine</strong>
            </div>

            <div className="spec-card">
              <span>Cubic Capacity</span>
              <strong>220 cc</strong>
            </div>

            <div className="spec-card">
              <span>Transmission</span>
              <strong>Manual</strong>
            </div>

            <div className="spec-card">
              <span>Fuel Type</span>
              <strong>Petrol</strong>
            </div>

            <div className="spec-card">
              <span>Battery</span>
              <strong>12V</strong>
            </div>

            <div className="spec-card">
              <span>Weight</span>
              <strong>155 kg</strong>
            </div>

            <div className="spec-card">
              <span>Max Speed</span>
              <strong>134 Kmph</strong>
            </div>

            <div className="spec-card">
              <span>Mileage</span>
              <strong>38 Kmpl</strong>
            </div>

          </div>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default Pulsar220;